import { useEffect, useRef, useState, type ReactNode } from 'react';
import { NavLink, useLocation } from '../router';

import { Brand } from './Brand';
import { Icon } from './Icon';

export function PublicLayout({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButton = useRef<HTMLButtonElement>(null);
  const { pathname } = useLocation();

  useEffect(() => setMenuOpen(false), [pathname]);
  useEffect(() => {
    if (!menuOpen) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      setMenuOpen(false);
      menuButton.current?.focus();
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [menuOpen]);

  return (
    <div className="public-shell">
      <header className="public-header">
        <Brand />
        <button
          ref={menuButton}
          className="icon-button public-menu-button"
          type="button"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          aria-controls="public-navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <Icon name={menuOpen ? 'close' : 'menu'} />
        </button>
        <nav id="public-navigation" className={`public-nav ${menuOpen ? 'open' : ''}`} aria-label="Public navigation">
          <NavLink to="/help">Help</NavLink>
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink className="button button-tonal" to="/login">Sign in</NavLink>
        </nav>
      </header>
      <main>{children}</main>
      <footer className="public-footer">
        <Brand />
        <p>Local texting first. Optional sync when you choose it.</p>
        <nav aria-label="Legal navigation">
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink to="/terms">Terms</NavLink>
          <NavLink to="/acceptable-use">Acceptable use</NavLink>
          <NavLink to="/delete-account">Delete account</NavLink>
          <a href="mailto:messavo@mehebub.com">Contact</a>
        </nav>
        <small>© 2026 Messavo. SMS, MMS, data, and carrier charges may apply.</small>
      </footer>
    </div>
  );
}
